/**
 * Configuration for HomeTypeSlider filters
 * Only store IDs and filter behavior - names and images fetched from database
 */

// List of filter IDs to display in the slider (order matters)
// Use 199 for Chalet display (has image), but filter by both 199 and 216
export const SLIDER_FILTER_IDS = [199, 188, 187, 183, 198];

// Filter behavior configuration by ID
export const HOME_TYPE_FILTERS = {
  // Chalet - filters by house type (Cottage) - includes both duplicate IDs
  199: {
    type: 'houseType',
    houseTypeIds: [199, 216]
  },

  // Pieds dans l'eau - filters by amenity (Waterfront)
  188: {
    type: 'amenity',
    amenityId: 188
  },

  // Nature - filters by amenity (Rural area)
  187: {
    type: 'amenity',
    amenityId: 187
  },

  // Couple - filters by amenity (Couples)
  183: {
    type: 'amenity',
    amenityId: 183
  },

  // Chambre d'hôte - filters by room type (Private suite B&B)
  198: {
    type: 'roomType'
  },
};
